import styles from './DownloadButton.module.scss';
import { DownloadIcon } from '../../icons/icons';
import axios from 'axios';
import { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { IPlan } from '../../interfaces/IPlan';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const DownloadButton = () => {
  const appContext = useContext(AppContext);
  const { plan, selectedYear } = appContext;

  const planName = plan?.shortPlanName?.toLowerCase().trim() || '';
  const state = plan?.state?.toLowerCase().trim() || '';

  const allowedStates = ['florida', 'california', 'texas'];
  const allowedPlanNames = ['align senior care', 'procare advantage'];

  const isSpanishDownloadAvailable =
    allowedPlanNames.includes(planName) && allowedStates.includes(state);

  // console.log('Plan Name:', plan?.shortPlanName);
  // console.log('State:', plan?.state);
  // console.log('Selected Year:', selectedYear);

  // -------------------------------------------------
  // ✔ 2027 → redirect to Members → Plan Documents page
  // -------------------------------------------------
  const handleRedirect = () => {
    const confirmed = window.confirm(
      'Please navigate to the Members - Plan Documents page to download the Formulary Directories.'
    );

    if (confirmed) {
      window.location.href = '/for-members/plan-documents/';
    }
  };

  // -------------------------------------------------
  // ✔ 2026 → OLD download logic
  // -------------------------------------------------
  const handleData = (plan: IPlan | null, language: string) => {
    (async () => {
      const linkSource = `${baseURL}Drugs/Print/${selectedYear}?key=${plan?.contractId}&id=${plan?.id}&language=${language}`;

      const downloadLink = document.createElement('a');
      const fileName = `${plan?.planName} Formulary - ${plan?.stateAbbreviation} - ${language}.pdf`;

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.target = '_blank';
      downloadLink.style.display = 'none';

      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
    })();
  };

  // -------------------------------------------------
  // Buttons (shared rendering)
  // -------------------------------------------------
  const spanishButton = (
    <button
      className={`${styles.downloadButton} ${styles.icon} ${styles.baseline}`}
      onClick={() =>
        selectedYear === '2027'
          ? handleRedirect()
          : handleData(plan, 'Spanish')
      }
    >
      <DownloadIcon />
      <span>Spanish Download</span>
    </button>
  );

  const englishButton = (
    <button
      className={`${styles.downloadButton} ${styles.icon} ${styles.baseline}`}
      onClick={() =>
        selectedYear === '2027'
          ? handleRedirect()
          : handleData(plan, 'English')
      }
    >
      <DownloadIcon />
      <span>Download</span>
    </button>
  );

  return (
    <>
      {isSpanishDownloadAvailable && spanishButton}
      {englishButton}
    </>
  );
};

export default DownloadButton;
